import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import { CommonValidationMessages } from '../../../utils/Messages';

class BOMSetupReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            colDefs: [],
            requestDetails: {
                fromDate: "",
                toDate: "",
                typeList: [],
                idType: 0,
                accHeadList: [],
                idAccHead: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
            },
            paginationPageSize: 50,
            rowHeight: 40,
        };
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.requestDetails;
        let value = event.value;
        details[name] = value;
        this.setState({ requestDetails: details }, () => {
            if (name === 'idMaterialType') {
                this.getMasterItemSelectbyItemTypeVendorwise()
            } else if (name === 'idItem') {
                this.getMasterItemSelectbyIDVendorwiseRate()
            } else if (name === 'idTaxGroup') {
                this.getTaxStructureSelectbyID()
            }
        });
    }

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.requestDetails;
        details[name] = value;
        this.setState({ requestDetails: details }, () => {
        });
    }

    render() {
        return (
            <div className='item-wise-stock-detail-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[60%] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select details</p>
                            <div className='item-set flex gap-[15px]'>
                                <div className='item-grp w-full flex gap-[15px]'>
                                    <div className='input-set w-[30%] grid gap-[10px]'>
                                        <div className='input-grp w-full'>
                                            <label>From date</label>
                                            <input
                                                type='date'
                                                id='fromDate' name='fromDate'
                                                className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                                onChange={(event) => this.handleChange(event, 'fromDate')}
                                                disabled
                                            />
                                        </div>
                                        <div className='input-grp w-full'>
                                            <label>To date</label>
                                            <input
                                                type='date'
                                                id='toDate' name='toDate'
                                                className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`}
                                                onChange={(event) => this.handleChange(event, 'toDate')}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className='input-set w-[30%] grid gap-[10px] items-end'>
                                        <div className='input-grp w-full h-fit border bg-lightBlue border-[#D8E0F0] mt-[18.8px] px-[10px] py-[8px] rounded-[5px] flex items-center gap-[5px]'>
                                            <label className='radio-button w-full'>
                                                <input
                                                    type='radio'
                                                    id='all' name='record-selection'
                                                />
                                                <span className='custom-radio'></span>
                                                All records
                                            </label>
                                        </div>
                                        <div className='input-grp w-full h-fit border bg-lightBlue border-[#D8E0F0] mt-[18.8px] px-[10px] py-[8px] rounded-[5px] flex items-center gap-[5px]'>
                                            <label className='radio-button w-full'>
                                                <input
                                                    type='radio' id='selection'
                                                    name='record-selection'
                                                />
                                                <span className='custom-radio'></span>
                                                Selection wise
                                            </label>
                                        </div>
                                    </div>
                                    <div className='input-set w-[40%] grid gap-[10px]'>
                                        <div className='input-grp w-full'>
                                            <label>Select type</label>
                                            <MultiSelectDropdown
                                                drpIdentity="Select type"
                                                options={this.state.requestDetails.typeList}
                                                value={this.state.requestDetails.idType ? this.state.requestDetails.typeList.find(x => x.value === this.state.requestDetails.idType) : 0}
                                                onChange={(event) =>
                                                    this.handleChangeForDropdown(event, "idType")
                                                }
                                                className={this.validState?.error?.idType !== undefined ? "error" : ""}
                                            />
                                        </div>
                                        <div className='input-grp w-full'>
                                            <label>Select acc. head</label>
                                            <MultiSelectDropdown
                                                drpIdentity="Select head"
                                                options={this.state.requestDetails.accHeadList}
                                                value={this.state.requestDetails.idAccHead ? this.state.requestDetails.accHeadList.find(x => x.value === this.state.requestDetails.idAccHead) : 0}
                                                onChange={(event) =>
                                                    this.handleChangeForDropdown(event, "idAccHead")
                                                }
                                                className={this.validState?.error?.idAccHead !== undefined ? "error" : ""}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='btn-grp'>
                                    <button className='prm-btn mt-[13.61px]'>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{height: "calc(100vh - 337px)"}}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">BOM setup reports</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData} // Pass row data
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs} // Pass column definitions
                                    pagination={true} // Enable pagination
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default BOMSetupReports;